import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible")
          }
        })
      },
      { threshold: 0.1 }
    )

    const elements = this.element.querySelectorAll(".reveal, .reveal-left, .reveal-right, .stagger-children")
    elements.forEach((el) => this.observer.observe(el))
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }
}
